if (!customElements.get('sticky-atc-bar')) {
  customElements.define(
    'sticky-atc-bar',
    class StickyAtcBar extends HTMLElement {
      connectedCallback() {
        if (this.closest('quick-add-modal')) return;

        const sectionId = this.dataset.section;
        this.picker = document.querySelector(
          `variant-radios[data-section="${sectionId}"], variant-selects[data-section="${sectionId}"]`
        );
        this.mainForm = document.getElementById(this.dataset.productFormId);
        this.idInput = this.mainForm ? this.mainForm.querySelector('input[name="id"]') : null;
        this.mainButton = this.mainForm ? this.mainForm.querySelector('[name="add"]') : null;
        this.optionsFieldset = this.querySelector('[data-sticky-atc-options]');
        this.price = this.querySelector('[data-sticky-atc-price]');
        this.button = this.querySelector('[data-sticky-atc-button]');

        const variantJson = this.querySelector('script[type="application/json"]');
        this.variantData = variantJson ? JSON.parse(variantJson.textContent) : [];

        if (this.optionsFieldset) {
          this.optionsFieldset.addEventListener('change', this.onOptionChange.bind(this));
        }

        if (this.idInput && this.optionsFieldset) {
          this.onIdInputChange = () => {
            const radio = this.optionsFieldset.querySelector(`input[type="radio"][value="${this.idInput.value}"]`);
            if (radio) radio.checked = true;
          };
          this.idInput.addEventListener('change', this.onIdInputChange);
        }

        const mainPrice = document.getElementById(`price-${sectionId}`);
        if (mainPrice && this.price) {
          this.priceObserver = new MutationObserver(() => {
            this.price.innerHTML = mainPrice.innerHTML;
          });
          this.priceObserver.observe(mainPrice, { childList: true, subtree: true });
        }

        if (this.mainButton && this.button) {
          this.buttonObserver = new MutationObserver(this.mirrorButtonState.bind(this));
          this.buttonObserver.observe(this.mainButton, {
            attributes: true,
            childList: true,
            subtree: true,
            characterData: true,
          });
          this.mirrorButtonState();
        }

        this.resizeObserver = new ResizeObserver(() => {
          document.documentElement.style.setProperty('--sticky-atc-height', `${this.offsetHeight}px`);
        });
        this.resizeObserver.observe(this);
      }

      disconnectedCallback() {
        if (this.priceObserver) this.priceObserver.disconnect();
        if (this.buttonObserver) this.buttonObserver.disconnect();
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.idInput && this.onIdInputChange) this.idInput.removeEventListener('change', this.onIdInputChange);
        document.documentElement.style.removeProperty('--sticky-atc-height');
      }

      onOptionChange(event) {
        if (!this.picker || event.target.type !== 'radio') return;
        const variant = this.variantData.find((variant) => variant.id === Number(event.target.value));
        if (!variant) return;

        const selects = this.picker.querySelectorAll('select');
        const fieldsets = this.picker.querySelectorAll('fieldset');
        variant.options.forEach((optionValue, index) => {
          if (selects.length) {
            if (selects[index]) selects[index].value = optionValue;
          } else if (fieldsets[index]) {
            Array.from(fieldsets[index].querySelectorAll('input[type="radio"]')).forEach((radio) => {
              radio.checked = radio.value === optionValue;
            });
          }
        });

        this.picker.dispatchEvent(new Event('change'));
      }

      mirrorButtonState() {
        this.button.toggleAttribute('disabled', this.mainButton.hasAttribute('disabled'));
        if (this.mainButton.hasAttribute('aria-disabled')) {
          this.button.setAttribute('aria-disabled', this.mainButton.getAttribute('aria-disabled'));
        } else {
          this.button.removeAttribute('aria-disabled');
        }
        this.button.classList.toggle('loading', this.mainButton.classList.contains('loading'));

        const mainText = this.mainButton.querySelector('span');
        const text = this.button.querySelector('span');
        if (mainText && text) text.textContent = mainText.textContent;

        const mainSpinner = this.mainButton.querySelector('.loading-overlay__spinner');
        const spinner = this.button.querySelector('.loading-overlay__spinner');
        if (mainSpinner && spinner) spinner.classList.toggle('hidden', mainSpinner.classList.contains('hidden'));
      }
    }
  );
}
